import PersonalForm from './PersonalForm';

export default PersonalForm;
